import { render, staticRenderFns } from "./baidu-set.vue?vue&type=template&id=3ddfda04&scoped=true"
import script from "./baidu-set.vue?vue&type=script&lang=js"
export * from "./baidu-set.vue?vue&type=script&lang=js"
import style0 from "./baidu-set.vue?vue&type=style&index=0&id=3ddfda04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddfda04",
  null
  
)

export default component.exports